import { render } from "./spinner-ball-beat.vue?vue&type=template&id=1a0ee73c"
const script = {}

import "./spinner-ball-beat.vue?vue&type=style&index=0&id=1a0ee73c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__